import React, {createContext, useReducer} from "react";
import {QCDashboardReducer} from "../reducer/QCDashboardReducer";

export const QCDashboardContext = createContext();

const initialState = {
    isLoading: true,
    widgetDataMap: {}
};

const QCDashboardContextProvider = (props) => {
    const [qcViewModel, qcDispatch] = useReducer(QCDashboardReducer, initialState);
    return (
        <QCDashboardContext.Provider value={{qcViewModel, qcDispatch}}>
            {props.children}
        </QCDashboardContext.Provider>
    );
};

export default QCDashboardContextProvider;



// WEBPACK FOOTER //
// ./src/commons/context/QCDashboardContext.js